/* eslint-disable no-tabs */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
  // mode: 'hash',
  // bash: '/',
  // routes: [// 路由使用懒加载，也叫延迟加载，即在需要的时候进行加载，随用随载，减少首页加载用时。
  {
    path: '/',
    component: () => import('@/components/system'),
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home'),
        meta: [
          {
            url: '',
            name: '首页'
          }
        ]
      },
      {
        path: '/enterVideo',
        name: 'enterVideo',
        component: () => import('@/views/enterVideo'),
        meta: [
          {
            url: '',
            name: '企业视频'
          }
        ]
      },
      {
        path: '/tracePatrolRecord',
        name: 'tracePatrolRecord',
        component: () => import('@/views/tracePatrolRecord/index'),
        meta: [
          {
            url: '',
            name: '巡查记录'
          }
        ]
      },
      {
        path: '/deviceMapPoint',
        name: 'deviceMapPoint',
        component: () => import('@/views/deviceMapPoint/index'),
        meta: [
          {
            url: '',
            name: '设备点位'
          }
        ]
      },
      {
        path: '/stockhome',
        name: 'stockhome',
        component: () => import('@/views/home/stockhome.vue'),
        meta: [
          {
            url: '',
            name: '首页'
          }
        ]
      },
      {
        path: '/fishhome',
        name: 'fishhome',
        component: () => import('@/views/home/fishhome.vue'),
        meta: [
          {
            url: '',
            name: '首页'
          }
        ]
      },
      {
        path: '/system/menu/list',
        name: 'systemMenuList',
        component: systemMenuList =>
          require(['@/components/system/menu/list'], systemMenuList),
        meta: [
          {
            url: '',
            name: '系统管理'
          },
          {
            url: '',
            name: '菜单管理'
          }
        ]
      },
      {
        path: '/system/role/list',
        name: 'systemRoleList',
        component: systemRoleList =>
          require(['@/components/system/role/list'], systemRoleList),
        meta: [
          {
            url: '',
            name: '系统管理'
          },
          {
            url: '',
            name: '角色管理'
          }
        ]
      },
      {
        path: '/system/user/list',
        name: 'systemUserList',
        component: systemUserList =>
          require(['@/components/system/user/list'], systemUserList),
        meta: [
          {
            url: '',
            name: '系统管理'
          },
          {
            url: '',
            name: '员工管理'
          }
        ]
      },
      {
        path: '/system/dictionary/list',
        name: 'systemDictionaryList',
        component: systemDictionaryList =>
          require([
            '@/components/system/dictionary/list'
          ], systemDictionaryList),
        meta: [
          {
            url: '',
            name: '字典管理'
          },
          {
            url: '',
            name: '字典管理'
          }
        ]
      },
      // 基本信息
      {
        path: '/basicInfo/main',
        name: 'main',
        component: () => import('@/views/basicInfo/main'),
        meta: [
          {
            url: '',
            name: '基本信息'
          },
          {
            url: '',
            name: '主体信息'
          }
        ]
      },
      {
        path: '/basicInfo/person',
        name: 'person',
        component: () => import('@/views/basicInfo/person'),
        meta: [
          {
            url: '',
            name: '基本信息'
          },
          {
            url: '',
            name: '人员管理'
          }
        ]
      },
      {
        path: '/basicInfo/cstmr',
        name: 'cstmr',
        component: () => import('@/views/basicInfo/cstmr'),
        meta: [
          {
            url: '',
            name: '基本信息'
          },
          {
            url: '',
            name: '客户管理'
          }
        ]
      },
      {
        path: '/basicInfo/supplier',
        name: 'supplier',
        component: () => import('@/views/basicInfo/supplier'),
        meta: [
          {
            url: '',
            name: '基本信息'
          },
          {
            url: '',
            name: '供应商管理'
          }
        ]
      },
      {
        path: '/basicInfo/account',
        name: 'account',
        component: () => import('@/views/basicInfo/account'),
        meta: [
          {
            url: '',
            name: '基本信息'
          },
          {
            url: '',
            name: '账号管理'
          }
        ]
      },
      {
        path: '/basicInfo/maint',
        name: 'maint',
        component: () => import('@/views/basicInfo/maint'),
        meta: [
          {
            url: '',
            name: '基本信息'
          },
          {
            url: '',
            name: '信息维护'
          }
        ]
      },
      {
        path: '/basicInfo/management',
        name: 'management',
        component: () => import('@/views/basicInfo/management'),
        meta: [
          {
            url: '',
            name: '基本信息'
          },
          {
            url: '',
            name: '主体管理'
          }
        ]
      },
      // 其他管理
      {
        path: '/other/product',
        name: 'product',
        component: () => import('@/views/other/product'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '产品管理'
          }
        ]
      },
      {
        path: '/other/product/add',
        name: 'addProduct',
        component: () => import('@/views/other/product/add'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '产品管理'
          },
          {
            url: '',
            name: '新增产品'
          }
        ]
      },
      {
        path: '/other/acre',
        name: 'acre',
        component: () => import('@/views/other/acre'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '地块管理'
          }
        ]
      },
      {
        path: '/other/equipment',
        name: 'equipment',
        component: () => import('@/views/other/equipment'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '基础设施管理'
          }
        ]
      },
      // 生产概况
      {
        path: '/productOverview/plantSeason',
        name: 'plantSeason',
        component: () => import('@/views/productOverview/plantSeason'),
        meta: [
          {
            url: '',
            name: '生产概况'
          },
          {
            url: '',
            name: '种植季概况'
          }
        ]
      },
      {
        path: '/productOverview/growthData',
        name: 'growthData',
        component: () => import('@/views/productOverview/growthData'),
        meta: [
          {
            url: '',
            name: '生产概况'
          },
          {
            url: '',
            name: '生长数据'
          }
        ]
      },
      {
        path: '/productOverview/environmentData',
        name: 'environmentData',
        component: () => import('@/views/productOverview/environmentData'),
        meta: [
          {
            url: '',
            name: '生产概况'
          },
          {
            url: '',
            name: '环境数据'
          }
        ]
      },
      {
        path: '/productOverview/farmingRecord',
        name: 'farmingRecord',
        component: () => import('@/views/productOverview/farmingRecord'),
        meta: [
          {
            url: '',
            name: '生产概况'
          },
          {
            url: '',
            name: '农事记录'
          }
        ]
      },
      // 栋舍管理
      {
        path: '/other/house',
        name: 'house',
        component: () => import('@/views/other/house'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '栋舍管理'
          }
        ]
      },
      {
        path: '/other/farm',
        name: 'farm',
        component: () => import('@/views/other/farm'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '农事管理'
          }
        ]
      },
      // 畜禽养殖管理
      {
        path: '/other/livestock',
        name: 'livestock',
        component: () => import('@/views/other/livestock'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '畜禽养殖管理'
          }
        ]
      },
      {
        path: '/other/inputs',
        name: 'inputs',
        component: () => import('@/views/other/inputs'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '投入品管理'
          }
        ]
      },
      // 畜禽投入品
      {
        path: '/other/stockinputs',
        name: 'stockinputs',
        component: () => import('@/views/other/stockinputs'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '畜禽投入品管理'
          }
        ]
      },
      // 塘口管理
      {
        path: '/other/tangkou',
        name: 'tangkou',
        component: () => import('@/views/other/tangkou'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '塘口管理'
          }
        ]
      },
      // 渔业投入品管理
      {
        path: '/other/tangkouinputs',
        name: 'tangkouinputs',
        component: () => import('@/views/other/tangkouinputs'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '渔业投入品管理'
          }
        ]
      },
      {
        path: '/other/inputsInfo',
        name: 'inputsInfo',
        component: () => import('@/views/other/inputsInfo'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '投入品信息管理'
          }
        ]
      },
      {
        path: '/other/materiel',
        name: 'materiel',
        component: () => import('@/views/other/materiel'),
        meta: [
          {
            url: '',
            name: '其他管理'
          },
          {
            url: '',
            name: '其他物料管理'
          }
        ]
      },
      // 种植管理
      {
        path: '/produce/plantation/index',
        name: 'plantation',
        component: () => import('@/views/produce/plantation/index'),
        meta: [
          {
            url: '',
            name: '种植管理'
          }
        ]
      },
      {
        path: '/produce/plantation/detail',
        name: 'plantationDetail',
        component: () => import('@/views/produce/plantation/detail'),
        meta: [
          {
            url: '',
            name: '种植管理'
          },
          {
            url: '',
            name: '综合信息'
          }
        ]
      },
      // 渔业管理
      {
        path: '/produce/fishery/index',
        name: 'fishery',
        component: () => import('@/views/produce/fishery/index'),
        meta: [
          {
            url: '',
            name: '渔业管理'
          }
        ]
      },
      {
        path: '/produce/fishery/detail',
        name: 'fisheryDetail',
        component: () => import('@/views/produce/fishery/detail'),
        meta: [
          {
            url: '',
            name: '渔业管理'
          },
          {
            url: '',
            name: '综合信息'
          }
        ]
      },
      {
        path: '/produce/livestock/index',
        name: 'livestockSys',
        component: () => import('@/views/produce/livestock/index'),
        meta: [
          {
            url: '',
            name: '生产管理'
          }
        ]
      },
      // 宰杀管理 --畜禽
      {
        path: '/kill/livestock/index',
        name: 'livestockKill',
        component: () => import('@/views/kill/livestock/index'),
        meta: [
          {
            url: '',
            name: '宰杀管理'
          }
        ]
      },
      // 宰杀管理 --渔业
      {
        path: '/kill/fishery/index',
        name: 'fisheryKill',
        component: () => import('@/views/kill/fishery/index'),
        meta: [
          {
            url: '',
            name: '宰杀管理'
          }
        ]
      },
      // 宰杀产品管理 --渔业
      {
        path: '/other/slaughter/index',
        name: 'slaughter',
        component: () => import('@/views/other/slaughter/index'),
        meta: [
          {
            url: '',
            name: '其它管理'
          },
          {
            url: '',
            name: '宰杀产品管理'
          }
        ]
      },
      // 加工管理 --种植
      {
        path: '/kill/plantation/index',
        name: 'working',
        component: () => import('@/views/kill/plantation/index'),
        meta: [
          {
            url: '',
            name: '加工管理'
          }
        ]
      },
      {
        path: '/produce/livestock/detail',
        name: 'livestockDetail',
        component: () => import('@/views/produce/livestock/detail'),
        meta: [
          {
            url: '',
            name: '生产管理'
          },
          {
            url: '',
            name: '信息查看'
          }
        ]
      },
      // 物联网管理 种植管理
      {
        path: '/internet/plantation',
        name: 'internet',
        component: () => import('@/views/internet/plantation'),
        meta: [
          {
            url: '',
            name: '物联网管理'
          },
          {
            url: '',
            name: '种植管理'
          }
        ]
      },
      // 批次管理
      {
        path: '/batch',
        name: 'batch',
        component: () => import('@/views/batch'),
        meta: [
          {
            url: '',
            name: '批次管理'
          }
        ]
      },
      // 采购管理
      {
        path: '/purchase',
        name: 'purchase',
        component: () => import('@/views/purchase'),
        meta: [
          {
            url: '',
            name: '采购管理'
          }
        ]
      },
      {
        path: '/materialWarehousing',
        name: 'materialWarehousing',
        component: () => import('@/views/materialWarehousing'),
        meta: [
          {
            url: '',
            name: '物料入库'
          }
        ]
      },
      {
        path: '/retrievalWarehousing',
        name: 'retrievalWarehousing',
        component: () => import('@/views/retrievalWarehousing'),
        meta: [
          {
            url: '',
            name: '物料出库'
          }
        ]
      }, {
        path: '/stockOperate',
        name: 'stockOperate',
        component: () => import('@/views/stockOperate/index.vue'),
        meta: [
          {
            url: '',
            name: '操作明细'
          }
        ]
      },
      // 生产加工
      {
        path: '/production',
        name: 'production',
        component: () => import('@/views/production'),
        meta: [
          {
            url: '',
            name: '生产加工'
          }
        ]
      },
      // 包装管理
      {
        path: '/package',
        name: 'package',
        component: () => import('@/views/package'),
        meta: [
          {
            url: '',
            name: '包装管理'
          }
        ]
      },
      // 运输管理
      {
        path: '/transportation',
        name: 'transportation',
        component: () => import('@/views/transportation'),
        meta: [
          {
            url: '',
            name: '运输管理'
          }
        ]
      },
      // 检测管理
      {
        path: '/check',
        name: 'check',
        component: () => import('@/views/check'),
        meta: [
          {
            url: '',
            name: '检测管理'
          }
        ]
      },
      // 销售管理
      {
        path: '/sales',
        name: 'sales',
        component: () => import('@/views/sales'),
        meta: [
          {
            url: '',
            name: '销售管理'
          }
        ]
      },
      //畜牧业投入品结算管理
      {
        path: '/payment/livestock',
        name: 'livestockPayment',
        component: () => import('@/views/payment/livestock/index'),
        meta: [
          {
            url: '',
            name: '结算管理'
          }
        ]
      },
      //渔业投入品结算管理
      {
        path: '/payment/fish',
        name: 'paymentFish',
        component: () => import('@/views/payment/fish/index'),
        meta: [
          {
            url: '',
            name: '结算管理'
          }
        ]
      },
      //种植业投入品结算管理
      {
        path: '/payment/plantation',
        name: 'paymentPlant',
        component: () => import('@/views/payment/plantation/index'),
        meta: [
          {
            url: '',
            name: '结算管理'
          }
        ]
      },
      // 溯源二维码
      {
        path: '/qrcode',
        name: 'qrcode',
        component: () => import('@/views/qrcode'),
        meta: [
          {
            url: '',
            name: '溯源二维码'
          }
        ]
      },
      // 库存统计
      {
        path: '/inventoryStatistics',
        name: 'inventoryStatistics',
        component: () => import('@/views/inventoryStatistics'),
        meta: [
          {
            url: '',
            name: '库存统计'
          }
        ]
      },
      // 库存盘点
      {
        path: '/inventoryCounting',
        name: 'inventoryCounting',
        component: () => import('@/views/inventoryCounting'),
        meta: [
          {
            url: '',
            name: '库存盘点'
          }
        ]
      },
      // 库存统计
      {
        path: '/plantSeasonManage',
        name: 'plantSeasonManage',
        component: () => import('@/views/other/plantSeasonManage/index'),
        meta: [
          {
            url: '',
            name: '种植季管理'
          }
        ]
      },
      // 生产规划
      {
        path: '/productionProgramme',
        name: 'productionProgramme',
        component: () => import('@/views/productionProgramme/index'),
        meta: [
          {
            url: '',
            name: '生产规划'
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/system/login2')
  }
]

export default new Router({
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js